export const Card = {
  baseStyle: {
    color: "white",
    border: "1px solid",
    borderColor: "brand.300",
  },
}
